import { createReducer } from "@reduxjs/toolkit";

export const createImmerReducer = createReducer;
